<!-- Visualização normal (sem comparar versões) -->
<ng-container *ngIf="!comparingVersions">
    <div class="col-12" *ngIf="loading">
        <div class="row">
            <div class="col-12">
                <ngx-skeleton-loader [theme]="{
                            height: '244px',
                            margin:'0 0 24px'
                        }">
                </ngx-skeleton-loader>
            </div>
        </div>
    </div>

    <div class="row" *ngIf="!loading">
        <div class="col-12">
            <div class="dash-details-card">
                <app-empty-content [isVisible]="!data"
                    title="Nenhum dado encontrado"
                    description="Não foi encontrado nenhum dado de risco nesse cadastro"
                    icon="/assets/images/forgot-password-icon2.png">
                </app-empty-content>

                <ng-container *ngIf="data">
                    <div class="dash-details-card-header"></div>
                    <div class="dash-details-card-body">
                        <div class="row">
                            <div class="col-3">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        Limite operacional
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{data.operating_limit ?
                                        formatBrl(data.operating_limit) : '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-3">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        Risco
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{data.risk ?? '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-3" *ngIf="isFund">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        Patrimônio Líquido
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{data.equity ? formatBrl(data.equity) :
                                        '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12" *ngIf="isFund">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        Observações
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{data.observations && data.observations
                                        !==
                                        ' ' ? data.observations : '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-9" *ngIf="!isFund">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        Observações
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{data.observations && data.observations
                                        !==
                                        ' ' ? data.observations : '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</ng-container>

<!-- Visualização com comparação de versões -->
<ng-container *ngIf="comparingVersions">
    <!-- Template reutilizável -->
    <ng-template #versionTemplate let-versionType="versionType">
        <div class="dash-details-card">
            <app-empty-content [isVisible]="!getDataForView(versionType)"
                title="Nenhum dado encontrado"
                description="Não foi encontrado nenhum dado de risco nesse cadastro"
                icon="/assets/images/forgot-password-icon2.png">
            </app-empty-content>

            <ng-container *ngIf="getDataForView(versionType)">
                <div class="dash-details-card-header"></div>
                <div class="dash-details-card-body">
                    <div class="row">
                        <div class="col-6">
                            <div class="d-flex flex-column">
                                <span class="dash-details-card-item-subtitle">
                                    Limite operacional
                                </span>

                                <span class="dash-details-card-item-title"
                                    style="display: flex; align-items: center; gap: 6px;">
                                    <span
                                        *ngIf="getFieldComparisonIcon('operating_limit', versionType)"
                                        [innerHTML]="getFieldComparisonIcon('operating_limit', versionType)"></span>
                                    <span
                                        [ngClass]="getFieldStrikethroughClass('operating_limit', versionType)">
                                        {{getDataForView(versionType)?.operating_limit
                                        ?
                                        formatBrl(getFieldValueForDisplay('operating_limit',
                                        getDataForView(versionType)?.operating_limit,
                                        versionType)) : '--'}}
                                    </span>
                                </span>
                                <app-spacer [bottom]="16"></app-spacer>
                            </div>
                        </div>

                        <div class="col-6">
                            <div class="d-flex flex-column">
                                <span class="dash-details-card-item-subtitle">
                                    Risco
                                </span>

                                <span class="dash-details-card-item-title"
                                    style="display: flex; align-items: center; gap: 6px;">
                                    <span
                                        *ngIf="getFieldComparisonIcon('risk', versionType)"
                                        [innerHTML]="getFieldComparisonIcon('risk', versionType)"></span>
                                    <span
                                        [ngClass]="getFieldStrikethroughClass('risk', versionType)">
                                        {{getFieldValueForDisplay('risk',
                                        getDataForView(versionType)?.risk,
                                        versionType) ?? '--'}}
                                    </span>
                                </span>
                                <app-spacer [bottom]="16"></app-spacer>
                            </div>
                        </div>

                        <div class="col-6" *ngIf="isFund">
                            <div class="d-flex flex-column">
                                <span class="dash-details-card-item-subtitle">
                                    Patrimônio Líquido
                                </span>

                                <span class="dash-details-card-item-title"
                                    style="display: flex; align-items: center; gap: 6px;">
                                    <span
                                        *ngIf="getFieldComparisonIcon('equity', versionType)"
                                        [innerHTML]="getFieldComparisonIcon('equity', versionType)"></span>
                                    <span
                                        [ngClass]="getFieldStrikethroughClass('equity', versionType)">
                                        {{getDataForView(versionType)?.equity
                                        ?
                                        formatBrl(getFieldValueForDisplay('equity',
                                        getDataForView(versionType)?.equity,
                                        versionType)) : '--'}}
                                    </span>
                                </span>
                                <app-spacer [bottom]="16"></app-spacer>
                            </div>
                        </div>

                        <div class="col-12">
                            <div class="d-flex flex-column">
                                <span class="dash-details-card-item-subtitle">
                                    Observações
                                </span>

                                <span class="dash-details-card-item-title"
                                    style="display: flex; align-items: center; gap: 6px;">
                                    <span
                                        *ngIf="getFieldComparisonIcon('observations', versionType)"
                                        [innerHTML]="getFieldComparisonIcon('observations', versionType)"></span>
                                    <span
                                        [ngClass]="getFieldStrikethroughClass('observations', versionType)">
                                        {{getFieldValueForDisplay('observations',
                                        getDataForView(versionType)?.observations,
                                        versionType) &&
                                        getFieldValueForDisplay('observations',
                                        getDataForView(versionType)?.observations,
                                        versionType) !== ' ' ?
                                        getFieldValueForDisplay('observations',
                                        getDataForView(versionType)?.observations,
                                        versionType) : '--'}}
                                    </span>
                                </span>
                                <app-spacer [bottom]="16"></app-spacer>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </ng-template>

    <div class="row">
        <!-- Versão Principal (Main) -->
        <div class="col-6">
            <ng-container *ngIf="getLoadingForView('main')">
                <ngx-skeleton-loader [theme]="{
                            height: '244px',
                            margin:'0 0 24px'
                        }">
                </ngx-skeleton-loader>
            </ng-container>

            <ng-container *ngIf="!getLoadingForView('main')">
                <ng-container *ngIf="approvalService.approvalData.mainRevision">
                    <ng-container
                        *ngTemplateOutlet="versionTemplate; context: { versionType: 'main' }"></ng-container>
                </ng-container>

                <app-select-version-comparison
                    *ngIf="!approvalService.approvalData.mainRevision">
                </app-select-version-comparison>
            </ng-container>
        </div>

        <!-- Versão Comparando (Comparing) -->
        <div class="col-6">
            <ng-container *ngIf="getLoadingForView('comparing')">
                <ngx-skeleton-loader [theme]="{
                            height: '244px',
                            margin:'0 0 24px'
                        }">
                </ngx-skeleton-loader>
            </ng-container>

            <ng-container *ngIf="!getLoadingForView('comparing')">
                <ng-container
                    *ngIf="approvalService.approvalData.comparingRevision">
                    <ng-container
                        *ngTemplateOutlet="versionTemplate; context: { versionType: 'comparing' }"></ng-container>
                </ng-container>

                <app-select-version-comparison
                    *ngIf="!approvalService.approvalData.comparingRevision">
                </app-select-version-comparison>
            </ng-container>
        </div>
    </div>
</ng-container>